import type { RelanceAgendaEntry } from '../../types/customerFollowUp/relanceAgenda';

export interface ForecastDay {
    /** The calendar day as `YYYY-MM-DD`. */
    key: string;
    entries: RelanceAgendaEntry[];
}

const toKey = (year: number, monthIndex: number, day: number): string =>
    new Date(Date.UTC(year, monthIndex, day)).toISOString().slice(0, 10);

/**
 * The `days` UTC calendar days starting tomorrow, each with the relances due that day. Due dates are the
 * start of a UTC day, so they are bucketed by their UTC date; one already past lands on the first day
 * rather than disappearing from the forecast.
 */
export const buildForecastDays = (entries: RelanceAgendaEntry[], days: number, now: Date = new Date()): ForecastDay[] => {
    const forecast = Array.from({ length: days }, (_, i): ForecastDay => ({
        key: toKey(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1 + i),
        entries: [],
    }));
    for (const entry of entries) {
        const dueKey = new Date(entry.dueAt).toISOString().slice(0, 10);
        const day = dueKey < forecast[0].key ? forecast[0] : forecast.find(d => d.key === dueKey);
        day?.entries.push(entry);
    }
    return forecast;
};
